import React, { useMemo } from "react";

const COLORS = ["#E20613", "#F9B81E", "#E91E8C", "#F26C1E", "#9B30B5", "#39B54A", "#00A9E0"];

// Confettis CSS, sans dépendance. Le parent contrôle le montage/démontage.
// Désactivés automatiquement si prefers-reduced-motion (voir index.css).
export default function Confetti({ count = 90 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.7,
        duration: 2.4 + Math.random() * 1.8,
        color: COLORS[i % COLORS.length],
        rot: Math.random() * 360,
        size: 7 + Math.random() * 7,
        round: i % 3 === 0,
      })),
    [count]
  );

  return (
    <div aria-hidden="true">
      {pieces.map((p, i) => (
        <span
          key={i}
          className="yum-confetti-piece"
          style={{
            left: `${p.left}vw`,
            background: p.color,
            width: p.size,
            height: p.size * 1.4,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rot}deg)`,
            borderRadius: p.round ? "50%" : "2px",
          }}
        />
      ))}
    </div>
  );
}
